function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module media-embed/automediaembed
 */
import { Plugin } from 'ckeditor5/src/core';
import { LiveRange, LivePosition } from 'ckeditor5/src/engine';
import { Clipboard } from 'ckeditor5/src/clipboard';
import { Undo } from 'ckeditor5/src/undo';
import { global } from 'ckeditor5/src/utils';
import MediaEmbedEditing from './mediaembedediting';
import { insertMedia } from './utils';
var URL_REGEXP = /^(?:http(s)?:\/\/)?[\w-]+\.[\w-.~:/?#[\]@!$&'()*+,;=%]+$/;
/**
 * The auto-media embed plugin. It recognizes media links in the pasted content and embeds
 * them shortly after they are injected into the document.
 *
 * @extends module:core/plugin~Plugin
 */

var AutoMediaEmbed = /*#__PURE__*/function (_Plugin) {
  _inherits(AutoMediaEmbed, _Plugin);

  var _super = _createSuper(AutoMediaEmbed);

  /**
   * @inheritDoc
   */
  function AutoMediaEmbed(editor) {
    var _this;

    _classCallCheck(this, AutoMediaEmbed);

    _this = _super.call(this, editor);
    /**
     * The paste–to–embed `setTimeout` ID. Stored as a property to allow
     * cleaning of the timeout.
     *
     * @private
     * @member {Number} #_timeoutId
     */

    _this._timeoutId = null;
    /**
     * The position where the `<media>` element will be inserted after the timeout,
     * determined each time the new content is pasted into the document.
     *
     * @private
     * @member {module:engine/model/liveposition~LivePosition} #_positionToInsert
     */

    _this._positionToInsert = null;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(AutoMediaEmbed, [{
    key: "init",
    value: function init() {
      var _this2 = this;

      var editor = this.editor;
      var modelDocument = editor.model.document; // We need to listen on `Clipboard#inputTransformation` because we need to save positions of selection.
      // After pasting, the content between those positions will be checked for a URL that could be transformed
      // into media.

      this.listenTo(editor.plugins.get('ClipboardPipeline'), 'inputTransformation', function () {
        var firstRange = modelDocument.selection.getFirstRange();
        var leftLivePosition = LivePosition.fromPosition(firstRange.start);
        leftLivePosition.stickiness = 'toPrevious';
        var rightLivePosition = LivePosition.fromPosition(firstRange.end);
        rightLivePosition.stickiness = 'toNext';
        modelDocument.once('change:data', function () {
          _this2._embedMediaBetweenPositions(leftLivePosition, rightLivePosition);

          leftLivePosition.detach();
          rightLivePosition.detach();
        }, {
          priority: 'high'
        });
      });
      editor.commands.get('undo').on('execute', function () {
        if (_this2._timeoutId) {
          global.window.clearTimeout(_this2._timeoutId);

          _this2._positionToInsert.detach();

          _this2._timeoutId = null;
          _this2._positionToInsert = null;
        }
      }, {
        priority: 'high'
      });
    }
    /**
     * Analyzes the part of the document between provided positions in search for a URL representing media.
     * When the URL is found, it is automatically converted into media.
     *
     * @protected
     * @param {module:engine/model/liveposition~LivePosition} leftPosition Left position of the selection.
     * @param {module:engine/model/liveposition~LivePosition} rightPosition Right position of the selection.
     */

  }, {
    key: "_embedMediaBetweenPositions",
    value: function _embedMediaBetweenPositions(leftPosition, rightPosition) {
      var _this3 = this;

      var editor = this.editor;
      var mediaRegistry = editor.plugins.get(MediaEmbedEditing).registry; // TODO: Use marker instead of LiveRange & LivePositions.

      var urlRange = new LiveRange(leftPosition, rightPosition);
      var walker = urlRange.getWalker({
        ignoreElementEnd: true
      });
      var url = '';

      var _iterator = _createForOfIteratorHelper(walker),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var node = _step.value;

          if (node.item.is('$textProxy')) {
            url += node.item.data;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      url = url.trim(); // If the URL does not match to universal URL regexp, let's skip that.

      if (!url.match(URL_REGEXP)) {
        urlRange.detach();
        return;
      } // If the URL represents a media, let's use it.


      if (!mediaRegistry.hasMedia(url)) {
        urlRange.detach();
        return;
      }

      var mediaEmbedCommand = editor.commands.get('mediaEmbed'); // Do not anything if media element cannot be inserted at the current position (#47).

      if (!mediaEmbedCommand.isEnabled) {
        urlRange.detach();
        return;
      } // Position won't be available in the `setTimeout` function so let's clone it.


      this._positionToInsert = LivePosition.fromPosition(leftPosition); // This action mustn't be executed if undo was called between pasting and auto-embedding.

      this._timeoutId = global.window.setTimeout(function () {
        editor.model.change(function (writer) {
          _this3._timeoutId = null;
          writer.remove(urlRange);
          urlRange.detach();
          var insertionPosition; // Check if position where the media element should be inserted is still valid.
          // Otherwise leave it as undefined to use document.selection - default behavior of model.insertContent().

          if (_this3._positionToInsert.root.rootName !== '$graveyard') {
            insertionPosition = _this3._positionToInsert;
          }

          insertMedia(editor.model, url, insertionPosition);

          _this3._positionToInsert.detach();

          _this3._positionToInsert = null;
        });
      }, 100);
    }
  }], [{
    key: "requires",
    get:
    /**
     * @inheritDoc
     */
    function get() {
      return [Clipboard, Undo];
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "pluginName",
    get: function get() {
      return 'AutoMediaEmbed';
    }
  }]);

  return AutoMediaEmbed;
}(Plugin);

export { AutoMediaEmbed as default };